import React from 'react';
import BotService from '../../../../actions/ConversationAction';
import { useChatboxStateContext } from '/src/features/chatbox/context/ChatboxContext';
import * as purify from 'dompurify';

function QuickReply({ content, tracking }) {

    const { canSendDataToServer } = useChatboxStateContext();

    const { askBotNextQuestion } = BotService();
    if(!canSendDataToServer || content ==="null" || content === "") return <></>
    return (
        <button type='button' tracking={tracking} className="quickreply" onClick={() => askBotNextQuestion(tracking, content)}>
            <span dangerouslySetInnerHTML={{ __html: purify.sanitize(content, { sanitize: true }) }} />
        </button>
    )
}

QuickReply.defaultProps = {
    text: '',
    tracking: '',
}

export default QuickReply